declare namespace $ {

	export class $yuf_video_slider extends $yuf_number_range {
		precision( ): number
		value_max( ): number
		value_min( ): number
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=slider.view.tree.d.ts.map